module.exports = __webpack_public_path__ + "39d285c.woff2";